import { useMutation } from "@tanstack/react-query";
import { deleteAssistant } from "../api/deleteAssistant";

export const useDeleteAssistantMutation = () => {
  return useMutation({ mutationFn: deleteAssistant });
};
